import { ServiceSettingsMovementRestrictionStore } from './service-settings-movement-restriction.store';
import { Component, inject } from '@angular/core';
import {
    SERVICE_SETTINGS_MOVEMENT_RESTRICTION_TYPE_KEY,
} from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../modules/content/components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-settings-movement-restriction',
    templateUrl: './service-settings-movement-restriction.component.html',
    styleUrl: './service-settings-movement-restriction.component.scss',
    providers: [ServiceSettingsMovementRestrictionStore],
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingsMovementRestrictionComponent {

    public readonly store = inject(ServiceSettingsMovementRestrictionStore);

    protected readonly SERVICE_SETTINGS_MOVEMENT_RESTRICTION_TYPE_KEY = SERVICE_SETTINGS_MOVEMENT_RESTRICTION_TYPE_KEY;
}
